import React from 'react';
import axios from 'axios';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class AwardList extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('cs');

    const tooltipPreview = (
      <Tooltip id="tooltip-preview">Náhled</Tooltip>
    );
    const tooltipEdit = (
      <Tooltip id="tooltip-edit">Upravit</Tooltip>
    );
    const tooltipRemove = (
      <Tooltip id="tooltip-remove">Odstranit</Tooltip>
    );
    const tooltipEnable = (
      <Tooltip id="tooltip-enable">Zakázat odměnu</Tooltip>
    );
    const tooltipDisable = (
      <Tooltip id="tooltip-disable">Povolit odměnu</Tooltip>
    );

    const columns = [{
      Header: 'Název',
      accessor: 'name',
    }, {
      Header: 'Množství',
      accessor: 'count',
    }, {
      Header: 'Cena',
      accessor: 'moneyValue',
    }, {
      Header: 'Věnoval',
      accessor: 'donatedBy',
    }, {
      Header: 'Možnosti',
      style: { padding: '0px' },
      filterable: false,
      Cell: row => (
        <div className="row-menu">
          <OverlayTrigger placement="top" overlay={tooltipPreview}>
            <Link to={`/awards/preview/${row.original.id}`}>
              <FontAwesome
                name="eye"
                className="cursor-p"
              />
            </Link>
          </OverlayTrigger>
          {
            row.original.availability &&
            <OverlayTrigger placement="top" overlay={tooltipEnable}>
              <FontAwesome name="unlock" onClick={() => this.props.handleChangeAvailability(row.original)}
                           className="cursor-p" />
            </OverlayTrigger>
          }
          {
            !row.original.availability &&
            <OverlayTrigger placement="top" overlay={tooltipDisable}>
              <FontAwesome name="lock" onClick={() => this.props.handleChangeAvailability(row.original)}
                           className="cursor-p" />
            </OverlayTrigger>
          }
          <OverlayTrigger placement="top" overlay={tooltipEdit}>
            <Link to={`/awards/edit/${row.original.id}`}>
              <FontAwesome name="pencil-square-o" className="cursor-p" />
            </Link>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={tooltipRemove}>
            <FontAwesome name="trash" onClick={() => this.showModal(row.original)}
                         className="cursor-p" />
          </OverlayTrigger>
        </div>
      )
    }];

    const tableOptions = {
      showPagination: true,
      showPageSizeOptions: true,
      showPageJump: true,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      freezeWhenExpanded: false,
      filterable: true,
      sortable: true,
      resizable: true,
      defaultPageSize: 10,
      defaultSorted: [{
        id: 'name',
        desc: false
      }]
    };

    this.state = {
      awards: [],
      removeAward: null,
      columns,
      tableOptions
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.getAwards();
  };

  getAwards() {
    this.setState({
      tableOptions: {
        ...this.state.tableOptions,
        loading: true
      }
    });
    axios.get(this.props.api.awards)
      .then((result) => {
        result.data.forEach(function (elem) {
          if (elem['created']) elem['created'] = moment(elem['dateOfBirth']).format('LL');
          return elem;
        });
        this.setState({
          awards: result.data,
          tableOptions: {
            ...this.state.tableOptions,
            loading: false
          }
        });
      }).catch((error) => {
      console.log("Axios error: ", error);
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      removeAward: null
    })
  }

  showModal(award) {
    this.setState({
      showModal: true,
      removeAward: award
    })
  }

  render() {

    const { columns, tableOptions } = this.state;
    let { awards, removeAward } = this.state;

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Seznam odměn</h2>
          <Button className="btn-success btn-add" onClick={() => this.props.history.push('/awards/add')}>
            <FontAwesome name="plus" />
          </Button>
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <Table
            columns={columns}
            data={awards}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
            options={{}}
          />
        </div>
        {
          removeAward &&
          <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
            <Modal.Header closeButton className="text-danger bg-danger">
              <Modal.Title>Odstranění odměny</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Opravdu chcete odstranit odměnu: {removeAward.name}?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.closeModal}>Zrušit</Button>
              <Button className='btn btn-danger'
                      onClick={() => this.props.handleRemoveAward(removeAward)}>Odstranit</Button>
            </Modal.Footer>
          </Modal>
        }
      </div>
    );
  }
}

export default withRouter(AwardList);



/** WEBPACK FOOTER **
 ** ./src/containers/Awards/AwardList.js
 **/